<div class="dialog-content">
  <h1 class="title">
    {{ titleKey | translate }}
  </h1>
  <form [formGroup]="form" *ngIf="form">
    <ts-language-input formControlName="values" [languages]="supportedLanguages"></ts-language-input>
    <div class="error" *ngIf="missingLanguages.length">
      {{ 'error.required_languages_missing' | translate : { languages: missingLanguages.join(', ') } }}
    </div>
  </form>
  <div class="error" *ngIf="errorKey">
    {{ errorKey | translate : errorParams }}
  </div>
  <div class="flex-row button-container">
    <button class="btn btn-outline-danger" (click)="close()" type="button">
      <i class="ri-close-fill"></i>
      {{ 'button.cancel' | translate }}
    </button>
    <button class="btn btn-primary" (click)="submit()" [disabled]="!form?.valid" type="button">
      <i class="ri-save-line"></i>
      {{ 'button.save' | translate }}
    </button>
  </div>
  <ts-loading-overlay *ngIf="pending" message="alert.saving"></ts-loading-overlay>
</div>
